import React from 'react';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function Abstract () {
    return (
        <Container maxWidth="md" sx={{margin: 4}} >
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
          <Stack>
              <Typography variant="h6" component="h2" sx={{fontWeight: 600, textAlign: { xs: 'left', md: 'right' } }}>
                ABSTRACT
              </Typography>
          </Stack>
          <Stack>
              <Typography variant="body1" component="span" sx={{'textAlign': 'justify' }}>
                Humans possess a unique ability to perceive meaningful patterns
                in ambiguous stimuli, a cognitive phenomenon known as pareido-
                lia. This paper introduces Shape2Animal framework to mimics this
                imaginative capacity by reinterpreting natural object silhouettes,
                such as clouds, stones, or flames, as plausible animal forms. Our
                automated framework first performs open-vocabulary segmentation
                to extract object silhouette and interprets semantically appropriate
                animal concepts using vision-language models. It then synthesizes
                an animal image that conforms to the input shape, leveraging text-
                to-image diffusion model and seamlessly blends it into the original
                scene to generate visually coherent and spatially consistent compo-
                sitions. We evaluated Shape2Animal on a diverse set of real-world
                inputs, demonstrating its robustness and creative potential. Our
                Shape2Animal can offer new opportunities for visual storytelling,
                educational content, digital art, and interactive media design.
              </Typography>
          </Stack>
        </Stack>
        </Container>
    );
};
export default Abstract;